import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { CheckoutService } from '../../domains/payment/payment/services/checkout.service';

export const checkoutGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
): Promise<boolean> => {
  const checkoutService = inject(CheckoutService);
  const router = inject(Router);

  try {
    const { purchaseIntentId } = route.queryParams as {
      purchaseIntentId?: string;
    };

    if (purchaseIntentId) {
      await checkoutService.validatePurchaseIntent(purchaseIntentId);
      return true;
    }

    return true;
  } catch {
    await router.navigate(['/portal/dashboard']);
    return false;
  }
};
